export const LEARNING_PRIORITY = 'Learning Priority';
export const COMPETENCY_DEFAULT_PRACTICE_LEVEL = 0;
export const competencySteps = ['Select Competencies', 'Reflect on them'];

export const DEFAULT_SKILL_PRACTICE_LEVEL_VALUE = {
  DONT_EXIST: 0,
  EXIST_VALID: 1
};

export const SKILL_OPERATION = {
  ADD_SKILL: 'add_skill',
  UPDATE_SKILL: 'update_skill',
  REMOVE_SKILL: 'remove_skill'
};
